// Carrier-specific constants shared across provider modules. Domain
// facts about airlines that affect seat-selection / fare rules — kept
// out of any single provider so multi-provider consumers (kyte +
// amadeus today) read from one source.

export const RYANAIR_CARRIER_CODES = ['FR', 'RR', 'RK'];
export const WIZZAIR_CARRIER_CODES = ['W6', 'W4', 'W9'];
export const EASYJET_CARRIER_CODES = ['U2'];
